import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { UPDATE_ORGANIZATION_LOGIN } from "../types";
import {
  updateOrganizationLoginPending,
  updateOrganizationLoginFulfilled,
  updateOrganizationLoginRejected,
} from "../actions";

import { sendApiRequest, notifyError, notifySuccess } from "../../../actions";

import { ORGANIZATION_MESSAGES } from "../constants/organizationMessages";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "put",
  url: "organization/UpdateOrganizationLoginRule",
  onSuccess: [
    updateOrganizationLoginFulfilled,
    (response) => notifySuccess(ORGANIZATION_MESSAGES.SUCCESS),
  ],
  onError: [
    updateOrganizationLoginRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const updateOrganizationInfoEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(UPDATE_ORGANIZATION_LOGIN.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      return merge(
        of(updateOrganizationLoginPending()),
        of(sendApiRequest(createPayload({ ...payload }), meta))
      );
    })
  );

export default updateOrganizationInfoEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/updateOrganizationInfoEpic.js